import { useTranslation } from "react-i18next";
import { JobLanguage } from "./enums/jobs.enum";

export const serverApi: string = `${process.env.REACT_APP_API_URL}`;

export const Messages = {
  error1: "Something went wrong!",
  error2: "Please login first!",
  error3: "Please fulfill all inputs!",
  error4: "Message is empty!",
  error5: "Only images with jpeg, jpg, png format allowed!",
};

export enum ErrorMessages {
  SOMETHING_WENT_WRONG = "Something went wrong!",
  NO_DATA_FOUND = "No data is found!",
  CREATE_FAILED = "Create is failed!",
  UPDATE_FAILED = "Update is failed!",

  USED_NICK_PHONE = "You are inserting already used nick or phone!",
  TOKEN_CREATION_FAILED = "Token creation error!",
  NO_MEMBER_NICK = "No member with that member nick!",
  BLOCKED_USER = "You have been blocked, contact the restaurant!",
  WRONG_PASSWORD = "Wrong password, please try again!",
  NOT_AUTHENTICATED = "You are not authenticated, Please login first!",

  ACCESS_TOKEN_EXPIRED = "Access token expired!",
  REFRESH_TOKEN_EXPIRED = "Refresh token expired!",

  ACCESS_TOKEN_REQUIRED = "Access token required",
  REFRESH_TOKEN_REQUIRED = "Refresh token required",

  INVALID_ACCESS_TOKEN = "Invalid access token",
  INVALID_REFRESH_TOKEN = "Invalid refresh token",
}

export const getLanguageName = (lang: string, t: any): string => {
  const languages: { [key: string]: string } = {
    [JobLanguage.UZ]: t("uzbek"),
    [JobLanguage.EN]: t("english"),
    [JobLanguage.KR]: t("korean"),
  };
  return languages[lang] || "O'zbekcha";
};
